import { useState } from 'react';

interface PackageContentsProps {
  bookId: string;
}

const FILES = [
  'manuscript.docx',
  'manuscript.epub',
  'ebook-cover.png',
  'paperback-cover.png',
  'metadata.json',
  'README.txt',
];

const DOWNLOADABLE_FILES: Array<{ key: string; label: string }> = [
  { key: 'manuscript.docx', label: 'Manuscript (DOCX)' },
  { key: 'manuscript.epub', label: 'eBook (EPUB)' },
  { key: 'ebook-cover.png', label: 'Cover (PNG)' },
  { key: 'paperback-cover.png', label: 'Paperback Spread' },
];

export function PackageContents({ bookId }: PackageContentsProps) {
  const [loadingFile, setLoadingFile] = useState<string | null>(null);

  async function handleFileDownload(filename: string) {
    setLoadingFile(filename);
    try {
      const res = await fetch(`/api/book/${bookId}/file/${filename}`, { credentials: 'include' });
      if (!res.ok) return;
      const { url } = await res.json();
      window.open(url, '_self');
    } finally {
      setLoadingFile(null);
    }
  }

  return (
    <section>
      <div className="text-[10px] tracking-[0.14em] uppercase text-placeholder mb-4">
        <span className="text-primary/60" aria-hidden="true">§</span> What's Inside
      </div>

      <div className="rounded-card border border-border bg-card p-5">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {FILES.map((file) => (
            <span key={file} className="font-mono text-xs text-muted-foreground">
              {file}
            </span>
          ))}
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-x-4 gap-y-1">
        <span className="text-xs text-muted-foreground">Download individually:</span>
        {DOWNLOADABLE_FILES.map(({ key, label }) => (
          <button
            key={key}
            onClick={() => handleFileDownload(key)}
            disabled={loadingFile === key}
            aria-label={`Download ${label}`}
            className="text-xs text-foreground hover:text-primary transition-colors duration-80 cursor-pointer bg-transparent border-none p-0 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1 disabled:opacity-50"
          >
            {loadingFile === key ? 'Downloading…' : label}
          </button>
        ))}
      </div>
    </section>
  );
}
